module.exports = __webpack_public_path__ + "static/media/project_3.48f8838d.webp";